var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.run !== null)?_c('coozzy-alert',{attrs:{"variant":_vm.variant}},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.variant === 'danger' && _vm.errorMessage)?[_c('br'),_c('br'),_vm._v(" "+_vm._s(_vm.$t('message.generic.error'))+": "),_c('br'),_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]:_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }